export class DroitModelDTO {
  idUser: number;
  commerce : boolean = false;
  fraisGeneraux : boolean = false;
  exploitation : boolean = false;
  idSociete: number;
  codeSociete: string;
  codeCa1: string = null;
  createBc : boolean = false;
  livBc  : boolean = false;
  visualiseBC: boolean = false;
  valid1: boolean = false;
  valid2: boolean = false;
  valid3: boolean = false;
  valid4: boolean = false;
  valid5: boolean = false;
  importBCAValid: boolean = false;
//importBCNonProv: boolean = false;
  importBCProv: boolean = false;
  interfaceSage: boolean = false;
  usersManager: boolean = false;
  repositoriesManager: boolean = false;
  idLigneTableau: number;
  refuse : boolean = false;
  messageRefus : string;
}